import { PROJECT_USER_OK, PROJECT_USER_ERR } from "./project.action";

const InitState = {
  error: null,
  content: null,
};

export default function ProjectReducer(state = InitState, action) {
  switch (action.type) {
    case PROJECT_USER_OK: {
      return {
        ...state,
        error: null,
        content: action.payload.content,
      };
    }
    case PROJECT_USER_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: null,
      };
    }
    default:
      return state;
  }
}
